import { render, staticRenderFns } from "./VisualizarResponsaveis.vue?vue&type=template&id=8f6f1b56&"
import script from "./VisualizarResponsaveis.vue?vue&type=script&lang=js&"
export * from "./VisualizarResponsaveis.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarResponsaveis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports